import clock from './clock.svg';
import message from './message.svg';
import people from './people.svg';
import pin from './pin.svg';
import star from './star.svg';

export { clock, message, people, pin, star };
